<script setup lang="ts">
import { locale_float } from '~/types/shared'

const props = defineProps<{
	row: any
}>()

const { t } = useI18n()
</script>

<template>
	<div>
		<div v-if="['cs_issue_order_partner_commission', 'cs_topup_order_partner_commission'].includes(row.slug)">
			<div class="text-zinc-800 dark:text-zinc-300" v-if="row.commission_percent">
				{{ $t('commission') }}: {{ locale_float(row.commission_percent) }}%
			</div>
			<div class="text-zinc-800 dark:text-zinc-300" v-if="row.level">
				{{ $t('level') }}: {{ locale_float(row.level) }}
			</div>
		</div>

		<div v-if="['asinx_blue_mc_activated', 'hipay_blue_mc_activated'].includes(row.slug)">
			<p v-if="row.commission_percent" class="font-mono">{{ $t('commission_label') }}: {{ locale_float(row.commission_percent) }}%</p>
		</div>

		<div v-if="row.slug === 'blue_c_update_otp_email_success'">
			<p v-if="row.ax_otp_email || row.hp_otp_email" class="font-mono">{{ $t('email_label') }}: {{ row.ax_otp_email || row.hp_otp_email }}</p>
			<p v-if="row.ax_otp_email_update_response" class="font-mono">{{ $t('message_label') }}: {{ row.ax_otp_email_update_response.original?.message }}</p>
			<p v-if="row.ax_otp_email_update_response" class="font-mono">{{ $t('code_label') }}: {{ row.ax_otp_email_update_response.original?.code }}</p>
			<p v-if="row.hp_otp_email_update_response" class="font-mono">{{ $t('message_label') }}: {{ row.hp_otp_email_update_response.message }}</p>
			<p v-if="row.hp_otp_email_update_response" class="font-mono">{{ $t('code_label') }}: {{ row.hp_otp_email_update_response.code }}</p>
			<p v-if="row.tg_notification_sent" class="font-mono">{{ $t('notification_sent') }}: {{ row.tg_notification_sent }}</p>
			<p v-if="row.tg_notification_failed" class="font-mono">{{ $t('notification_failed') }}: {{ row.tg_notification_failed }}</p>
		</div>

		<div v-if="row.slug !== 'ax_card_status_change'">
			<div class="space-y-2">
				<div>
					<UBadge 
						v-if="row.ax_data?.decrypted_result?.transaction?.merchantName" 
						leading-icon="i-heroicons-shopping-cart-16-solid"
						size="md"
						color="gray"
						variant="soft"
					>
						{{ row.ax_data?.decrypted_result?.transaction?.merchantName }}
					</UBadge>
				</div>

				<div>
					<UBadge 
						v-if="row.ax_data?.decrypted_result?.cardNo?.slice(-4) || row.label" 
						leading-icon="i-heroicons-credit-card-20-solid"
					>
						**** {{ row.ax_data?.decrypted_result?.cardNo?.slice(-4) || row.label }}
					</UBadge>
				</div>
			</div>

			<div>
				<span v-if="row.slug === 'ax_transaction_created' && row.ax_data?.decrypted_result?.transaction?.balance !== undefined && row.ax_data?.decrypted_result?.transaction?.balance !== null">
					{{ $t('balans_posle_operatsii', {locale_float: locale_float(row.ax_data?.decrypted_result?.transaction?.balance)}) }}
				</span>
				<template v-if="row.slug === 'user_deposit_usdt_trc20'">
					<span v-if="row.tx?.amount">{{ $t('summa_transaktsii', {locale_float: locale_float(row.tx.amount), toUpperCase: row.tx?.token?.toUpperCase()}) }}</span>
					<div v-if="row.user_usdt_balance_after">
						{{ $t('usdt_balance_posle_oper', {locale_float: locale_float(row.user_usdt_balance_after)}) }}
					</div>
					<div v-if="row.tx?.address_from">
						{{ $t('adress_otpravitel') }}
						<ULink :to="`https://tronscan.org/#/address/${row.tx.address_from}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.tx.address_from }}</ULink>
					</div>
					<div v-if="row.tx?.address_to">
						{{ $t('adress_poluchat') }}
						<ULink :to="`https://tronscan.org/#/address/${row.tx.address_to}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.tx.address_to }}</ULink>
					</div>
					<div v-if="row.tx?.tx_hash">
						{{ $t('trans_hash') }}
						<ULink :to="`https://tronscan.org/#/transaction/${row.tx.tx_hash}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.tx.tx_hash }}</ULink>
					</div>
					<div v-if="row.tx?.block_num">
						{{ $t('trans_block', {block_num: row.tx.block_num}) }}
					</div>
				</template>
				<template v-else-if="row.slug === 'ag_usdt_trc20'">
					<div v-if="row.address_from">
						{{ $t('adress_otpravitel') }}
						<ULink :to="`https://tronscan.org/#/address/${row.address_from}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.address_from }}</ULink>
					</div>
					<div v-if="row.address_to">
						{{ $t('adress_poluchat') }}
						<ULink :to="`https://tronscan.org/#/address/${row.address_to}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.address_to }}</ULink>
					</div>
					<div v-if="row.tx_hash">
						{{ $t('trans_hash') }}
						<ULink :to="`https://tronscan.org/#/transaction/${row.tx_hash}`" target="_blank" class="text-zinc-800 dark:text-zinc-300 whitespace-nowrap">{{ row.tx_hash }}</ULink>
					</div>
				</template>
				<template v-else-if="row.slug === 'payment_for_issue_blue_c'">
					<div>{{ $t('usdt_balance_do_oper', {locale_float: locale_float(row.user_usdt_balance_before)}) }}</div>
					<div>{{ $t('usdt_balance_posle_oper', {locale_float: locale_float(row.user_usdt_balance_after)}) }}</div>
				</template>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt && row.ax_data?.decrypted_result?.transaction?.feeAmount">
				{{ $t('summ_spis_s_komiss', {locale_float: locale_float((parseFloat(row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt) +
					parseFloat(row.ax_data?.decrypted_result?.transaction?.feeAmount))), transCurrency: row.ax_data?.decrypted_result?.transaction?.transCurrency}) }}
				<span class="text-xs text-zinc-500">{{ $t('vkluch_komiss', {locale_float: locale_float(row.ax_data?.decrypted_result?.transaction?.feeAmount)}) }}</span>
			</div>
			<div v-else-if="row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt">
				{{ $t('summ_spis', {locale_float: locale_float(row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt), transCurrency: row.ax_data?.decrypted_result?.transaction?.transCurrency}) }}
			</div>
			<div v-if="row.code && row.slug === 'ax_transaction_verification_code'">
				{{ $t('kod_podtv') }} <span class="font-mono">{{ row.code }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.status">
				{{ $t('status') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.status }}</span>
			</div>
			<div v-if="row.tg_notification_sent_result">
				{{ $t('result_otprav_uvedom') }} <span class="font-mono">{{ row.tg_notification_sent_result === 'success' ? $t('success') : $t('fail') }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.type">
				{{ $t('tip_operat') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.type }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.requestOrderId">
				{{ $t('id_zayavki') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.requestOrderId }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.uniqueNo">
				{{ $t('unik_number') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.uniqueNo }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.userBankcardId">
				{{ $t('id_bank_karty') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.userBankcardId }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.amount">
				{{ $t('oper_summ') }} <span class="font-mono">{{ locale_float(row.ax_data?.decrypted_result?.amount) }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.currency">
				{{ $t('valuta_oper') }} <span class="font-mono">{{ row.ax_data?.decrypted_result?.currency }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.receiveAmount">
				{{ $t('summ_zachisl') }} <span class="font-mono">{{ locale_float(row.ax_data?.decrypted_result?.receiveAmount) }}</span>
			</div>
			<div v-if="row.ax_data?.decrypted_result?.transaction?.failure_reason">
				{{ $t('reason') }}:
				<span
					:class="{
						'text-red-600 font-semibold': row.ax_data?.decrypted_result?.transaction?.transStatus === 'DECLINED',
						'text-yellow-600 font-semibold': row.ax_data?.decrypted_result?.transaction?.transStatus === 'PENDING',
						'text-green-600 font-semibold': row.ax_data?.decrypted_result?.transaction?.transStatus === 'APPROVED'
					}"
				>
					{{ row.ax_data?.decrypted_result.transaction.failure_reason }}
				</span>
			</div>
		</div>
		<div v-else>
			<div>{{ $t('card****_slice', {slice: row.ax_data?.decrypted_result?.cardNo?.slice(-4)}) }}</div>
			<div v-if="row.ax_data?.decrypted_result?.transaction?.balance !== undefined && row.ax_data?.decrypted_result?.transaction?.balance !== null">
				{{ $t('balans_posle_operatsii', {locale_float: locale_float(row.ax_data?.decrypted_result?.balance)}) }}
			</div>
			<div v-if="row.ax_data?.decrypted_result?.reason">
				{{ $t('key', {reason: row.ax_data?.decrypted_result?.reason}) }}
			</div>
		</div>
	</div>
</template>
